import { SubscriptionIntegrationSchema } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import * as z from "zod/v4";

export const editSubscription = {
  name: "editSubscription" as const,
  input: z.object({
    subscriptionId: z.number(),
    updates: z.object({
      quantity: z.number().optional(),
      orderIntervalFrequency: z.number().optional(),
      orderIntervalUnit: z.enum(["day", "week", "month"]).optional(),
      nextChargeScheduledAt: z.string().optional(),
      price: z.string().optional(),
    }),
  }),
  output: z.object({
    subscription: SubscriptionIntegrationSchema,
  }),
};
